import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useCollection from 'Hooks/useCollection';
import { makeStyles } from '@material-ui/core';
import fr from 'facet-rest';
import Income from './Income';
import Expenses from './Expenses';
import IncomeVsExpenses from './IncomeVsExpensesBar';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: '1 1',
    flexWrap: 'wrap',
    gap: `${theme.spacing(2)}px`,
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
}));
export default function NewprintCashFlow({
  className,
}) {
  const classes = useStyles();
  const { householdResource } = useSimpleHousehold();

  const { collection: expenseSummary, setCollection: setExpenseSummary } = useCollection();
  useEffect(() => {
    const expenseSummaryLink = householdResource.relationship('expenseSummary')?.link('related');
    if (!expenseSummaryLink) return;

    expenseSummaryLink.get().then(setExpenseSummary);
  }, []);

  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpenses, setTotalExpenses] = useState(0);
  // recalculate total expenses on update to expenseSummary
  useEffect(() => {
    if (expenseSummary) {
      const [data] = expenseSummary;
      let total = 0;
      for (const attr of ['savingsMonthlyTotal', 'housingMonthlyTotal', 'transportationMonthlyTotal', 'lifestyleMonthlyTotal', 'debtMonthlyTotal']) {
        total += Number.parseFloat(data.attr(attr) || 0);
      }
      setTotalExpenses(total);
    }
  }, [expenseSummary]);

  const { collection: clients, setCollection: setClients } = useCollection();
  const handleIncomeTotal = () => {
    const total = clients.resources().list().reduce((acc, next) => Number.parseFloat(next.attr('netMonthlyIncome') || 0) + acc, 0);
    setTotalIncome(total);
  };
  useEffect(() => {
    if (householdResource) {
      householdResource.relationship(fr.relationships.clients.name).link('related').get().then(setClients);
    }
  }, [householdResource]);

  if (!householdResource || !clients) return <div className={classNames(classes.root, className)} />;

  return (
    <div className={classNames(classes.root, className)}>
      <IncomeVsExpenses income={totalIncome} expenses={totalExpenses} />
      <Income
        clientCollection={clients}
        total={totalIncome}
        setTotalIncome={handleIncomeTotal}
      />
      <Expenses
        expenseSummary={expenseSummary}
      />
    </div>
  );
}

NewprintCashFlow.defaultProps = {
  className: '',
};

NewprintCashFlow.propTypes = {
  className: PropTypes.string,
};
